import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useAuth from '../../Hooks/useAuth';
const MyOrderList = ({order}) => {
    const {user} = useAuth();
    return (
        <>
        {
            order.orderEmail === user.email ? 
            <tr key={order._id}>
                <td><img className="orderImage" src={order.img} alt="" /></td>
                <td>{order.name}</td>
                <td>{order.title}</td>
                <td>
                    {order.orderName} <br/>
                    <img className='orderimg' src={order.orderPhoto} alt="" />
                </td>
                <td>{order.status === false ?
                    <span className="red">PENDING</span> : <span className="green">OK</span>}
                </td>
                <td><Link to='/manageOrder'><Button>Manege Orders</Button></Link></td>
            </tr>
            : null
        }
        </>
    );
};

export default MyOrderList;